// Import league logos
import ligue1 from "../assets/league/Ligue_1.png";
import copa from "../assets/league/copa_pr.png";
import ligasec from "../assets/league/liga_sec.png";
import br from "../assets/league/Brasileiro_Série_A.png";
import juplier from "../assets/league/Jupiler_Pro_League.png";
import ufc from "../assets/league/UFC.png";
import uefaNations from "../assets/league/UEFA_Nations.png";
import rsl from "../assets/league/rsl.png";
import bundesliga from "../assets/league/Bundesliga.png";
import mls from "../assets/league/MLS.png";
import ligaportugal from "../assets/league/Primeira_Liga.png";
import seriaA from "../assets/league/Serie_A.png";
import premierLeague from "../assets/league/Premier_League.png";
import f1 from "../assets/league/F1.png";
import fifaWorldCup from "../assets/league/2026_FIFA_World_Cup.png";
import europaLeague from "../assets/league/UEFA_Europa_League.png";
import champions from "../assets/league/Logo_Champions_League.png";
import laliga from "../assets/league/LaLiga.png";



export default function Sports() {

    const leagueLogos = [
        { name: "Liga Portugal", src: ligaportugal },
        { name: "Copa do Portugal", src: copa },
        { name: "Champions League", src: champions },
        { name: "FIFA World Cup", src: fifaWorldCup },
        { name: "UEFA Nations League", src: uefaNations },
        { name: "La Liga", src: laliga },
        { name: "Europa League", src: europaLeague },
        { name: "Premier League", src: premierLeague },
        { name: "Serie A", src: seriaA },
        { name: "Liga Secundária", src: ligasec },
        { name: "JupilerPro League", src: juplier },
        { name: "ligue1", src: ligue1 },
        { name: "RSL", src: rsl },
        { name: "Bundesliga", src: bundesliga },
        { name: "MLS", src: mls },
        { name: "Formula 1", src: f1 },
        { name: "UFC", src: ufc },
        { name: "Brasileiro Série A", src: br },
      ];

    return (
        <section className="pb-10">
            <div className="container m-auto">
                <div className="mb-12 sm:mb-16">
                    <h1 className="text-2xl md:text-3xl max-w-3xl m-auto text-center font-bold text-white">
                        Todos os canais desportivos e competições em direto
                    </h1>
                </div>
                {(() => {
                    function importAll(requireContext) {
                        return requireContext.keys().map((key) => ({ key, src: requireContext(key) }));
                    }

                    const sportsContext = require.context('../assets/sports', false, /\.(webp|png|jpe?g|svg)$/);
                    const sportsImages = importAll(sportsContext)
                        .sort((a, b) => a.key.localeCompare(b.key))
                        .map((x) => x.src);
                    const sportsLoop = [...sportsImages, ...sportsImages];

                    return (
                        <>
                            <div className="sports-carousel">
                                <div className="sports-marquee">
                                    <div className="sports-track">
                                        {sportsLoop.map((src, index) => (
                                            <div className="sports-item" key={`sport-${index}`}><img src={src} alt={`Sport ${index + 1}`} /></div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="mb-12 sm:mb-16 mt-6 sm:mt-8">
                                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                                    {leagueLogos.map((logo, index) => (
                                        <div
                                        key={index}
                                        className="group bg-white backdrop-blur-md rounded-lg p-6 animate-slide-in-top"
                                        >
                                        <div className="flex items-center justify-center h-8">
                                            <img
                                            src={logo.src}
                                            alt={logo.name}
                                            className="max-h-14 max-w-full object-contain filter group-hover:brightness-110 group-hover:scale-125 transition-all duration-300"
                                            loading="lazy"
                                            />
                                        </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    );
                })()}
            </div>
        </section>
    );
}
